module.exports = __webpack_public_path__ + "static/media/service-metal.5340355b.jpg";